// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__17SRf","content":"styles_content__1AvDy","checkbox":"styles_checkbox__3-dOQ","checkboxLabel":"styles_checkboxLabel__2NY7H"};